export default "__VITE_ASSET__Bsmo6c2M__"